<template>
  <div class="home-body">
    <BlogList></BlogList>
    <AdBlock :slot-id="1" :count="1" :containerClass="'container xs-pb-30'" ad-area-override="public"></AdBlock>
  </div>

</template>


<script>
import _ from 'underscore'
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
  import BlogList from '../blog/BlogList'


export default {
    components: {
      BlogList
  },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .home-body {background:#FFFFFF;}
</style>



// WEBPACK FOOTER //
// BlogPage.vue?3cf9ac23